angular.
module("dx.webapp.printing").
component("dxExamPrintOptions", {
	templateUrl: "tmpl/printing/exam-print-options/exam-print-options-component.html",
	controller: "DxExamPrintOptionsController",
	controllerAs: "vm",
	bindings: {
		exam: "<",
		disabledStudentCodes: "<",
		onCancel: "&",
	},
});
